export const BASE_SEARCH_PRODUCTS_URL = "/busca";

export const PRODUCT_GROUPS = [
  {
    pathname: "/feminino",
    pageName: "Feminino",
  },
  {
    pathname: "/masculino",
    pageName: "Masculino",
  },
  {
    pathname: "/infantil",
    pageName: "Infantil",
  },
  {
    pathname: `${BASE_SEARCH_PRODUCTS_URL}?highlights=recent`,
    pageName: "Mais recentes",
  },
  {
    pathname: `${BASE_SEARCH_PRODUCTS_URL}?highlights=trending`,
    pageName: "Produtos em alta",
  },
  {
    pathname: `${BASE_SEARCH_PRODUCTS_URL}?highlights=mostSelled`,
    pageName: "Mais vendidos",
  },
];
